<form >
  <mat-form-field>
    <mat-select [formControl]="eventType" required>
      <mat-option *ngFor="let type of historyTypes"
                  [value]="type"
                  (click)="chooseType(type)">{{'RECORDS_LIST.STATUS.' + type | translate}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</form>
